import { Orbit } from "./Orbit.js";
export { Trajectory };
class Trajectory extends Orbit {
    constructor({ waypoint, center, radius, width, spacing, connection }) {
        super({ waypoint, center, radius, width, spacing });
        this.connection = connection;
    }
}
//# sourceMappingURL=Trajectory.js.map